// extracted by mini-css-extract-plugin
export default {"addAPlanLink":"wvC_rzXAybaOg5Fa-U-zU"};